import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentMethodPaypalLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 32,
	viewBox: "0 0 48 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4134_558)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z",
				fill: "url(#paint0_linear_4134_558)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 0.25H44C46.0711 0.25 47.75 1.92893 47.75 4V28C47.75 30.0711 46.0711 31.75 44 31.75H4C1.92893 31.75 0.25 30.0711 0.25 28V4C0.25 1.92893 1.92893 0.25 4 0.25Z",
				stroke: "black",
				strokeOpacity: .16,
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsxs("g", {
				clipPath: "url(#clip1_4134_558)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M22.3547 10.0002C22.2174 10.0002 22.0847 10.0492 21.9803 10.1384C21.8759 10.2276 21.8068 10.3511 21.7854 10.4866L20.8391 16.4866L19.9697 21.9999L19.9692 22.0045L19.9703 21.9999L20.8397 16.4866C20.8839 16.2064 21.1251 16.0002 21.4087 16.0002H24.1807C26.9706 16.0002 29.3384 13.9649 29.7709 11.2068C29.8038 10.9972 29.8215 10.7896 29.8255 10.5848V10.5845H29.8252C29.1162 10.2125 28.2836 10.0002 27.3714 10.0002H22.3547Z",
						fill: "#001C64"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M29.8252 10.5847C29.8214 10.7895 29.8035 10.9973 29.7706 11.2069C29.3382 13.965 26.9703 16.0004 24.1805 16.0004H21.4085C21.1249 16.0004 20.8836 16.2065 20.8394 16.4868L19.97 22L19.4244 25.459C19.4139 25.5258 19.418 25.5941 19.4364 25.6592C19.4548 25.7243 19.4871 25.7846 19.5311 25.836C19.575 25.8874 19.6296 25.9287 19.691 25.957C19.7524 25.9853 19.8192 26 19.8869 26H22.8958C23.0331 26 23.1659 25.951 23.2702 25.8619C23.3746 25.7727 23.4437 25.6492 23.4651 25.5136L24.2578 20.4867C24.3022 20.2065 24.5436 20 24.8271 20H26.5989C29.3887 20 31.7563 17.9648 32.1887 15.2069C32.4957 13.249 31.5104 11.4679 29.8252 10.5847Z",
						fill: "#0070E0"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M18.9362 6C18.7988 6 18.666 6.04904 18.5616 6.13827C18.4573 6.2275 18.3882 6.35107 18.3668 6.48672L16.0058 21.4587C15.9952 21.5255 15.9993 21.5938 16.0176 21.659C16.036 21.7241 16.0683 21.7844 16.1123 21.8359C16.1562 21.8873 16.2108 21.9286 16.2723 21.957C16.3337 21.9853 16.4006 22 16.4682 22H19.9697L20.839 16.4867L21.7853 10.4867C21.8067 10.3511 21.8758 10.2276 21.9802 10.1385C22.0846 10.0493 22.2174 10.0003 22.3546 10.0003H27.3711C28.2835 10.0003 29.1161 10.2129 29.8252 10.5844C29.8735 8.07338 27.8016 6 24.9525 6H18.9362Z",
						fill: "#003087"
					})
				]
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_4134_558",
			x1: 0,
			y1: 0,
			x2: 48,
			y2: 32,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopOpacity: .02 }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopOpacity: .08
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_4134_558",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 48,
				height: 32,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_4134_558",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16.2444,
				height: 20,
				fill: "white",
				transform: "translate(16 6)"
			})
		})
	] })]
});
export default SvgPaymentMethodPaypalLight;
